import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { homeReducer } from "@/components/home";
import authReducer from "@/components/auth/AuthSlice";
import { scanningReducer } from "@/components/scanning/ScanningSlice";
import evaluatorReducer from "@/components/evaluator/EvaluatorSlice";
import { setStoreGetter as setAxiosStoreGetter, setPersistorGetter, setLogoutAction } from "./axios";
import { logout } from "@/components/auth/AuthSlice";

import commonReducer from "./commonslice";
const rootReducer = combineReducers({
  home: homeReducer,
  auth: authReducer,
  scanning: scanningReducer,
  evaluator: evaluatorReducer,
  common: commonReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Add slices you want to persist here
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [PERSIST, REGISTER, PURGE],
      },
    }),
  devTools: import.meta.env.VITE_APP_ENV === "development",
});

export const persistor = persistStore(store);

// Set store getter for axios interceptor (avoids circular dependency)
setAxiosStoreGetter(() => store);

// Set persistor getter for axios interceptor (for 401 handling)
setPersistorGetter(() => persistor);

// Set logout action for axios interceptor (for 401 handling)
setLogoutAction(() => logout());

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
